export const SERVICE_TYPES = {
  // 1:1 classes
  CODINGAL_PRIME: 'Codingal Prime',

  // Group classes (4-5 students)
  CODINGAL_PLUS: 'Codingal Plus',

  // Group classes (2-3 students)
  CODINGAL_PREMIER: 'Codingal Premier',

  // Cohort classes (6-8 students)
  CODINGAL_PLAYGROUND: 'Codingal Playground',
}

// IMPORTANT: This list should reflect the values in backend's `CURRENCY_PAYMENT_GATEWAY_MAPPING` constant in `apps/billing/constants.py`.
export const STRIPE_SUPPORTED_CURRENCIES = [
  'usd',
  'aed',
  'afn',
  'all',
  'amd',
  'ang',
  'aoa',
  'ars',
  'aud',
  'awg',
  'azn',
  'bam',
  'bbd',
  'bdt',
  'bgn',
  'bif',
  'bmd',
  'bnd',
  'bob',
  'brl',
  'bsd',
  'bwp',
  'byn',
  'bzd',
  'cad',
  'cdf',
  'chf',
  'clp',
  'cny',
  'cop',
  'crc',
  'cve',
  'czk',
  'djf',
  'dkk',
  'dop',
  'dzd',
  'egp',
  'etb',
  'eur',
  'fjd',
  'fkp',
  'gbp',
  'gel',
  'gip',
  'gmd',
  'gnf',
  'gtq',
  'gyd',
  'hkd',
  'hnl',
  'htg',
  'huf',
  'idr',
  'ils',
  'isk',
  'jmd',
  'jpy',
  'kes',
  'kgs',
  'khr',
  'kmf',
  'krw',
  'kyd',
  'kzt',
  'lak',
  'lbp',
  'lkr',
  'lrd',
  'lsl',
  'mad',
  'mdl',
  'mga',
  'mkd',
  'mmk',
  'mnt',
  'mop',
  'mur',
  'mvr',
  'mwk',
  'mxn',
  'myr',
  'mzn',
  'nad',
  'ngn',
  'nio',
  'nok',
  'npr',
  'nzd',
  'pab',
  'pen',
  'pgk',
  'php',
  'pkr',
  'pln',
  'pyg',
  'qar',
  'ron',
  'rsd',
  'rub',
  'rwf',
  'sar',
  'sbd',
  'scr',
  'sek',
  'sgd',
  'shp',
  'sle',
  'sos',
  'srd',
  'std',
  'szl',
  'thb',
  'tjs',
  'top',
  'try',
  'ttd',
  'twd',
  'tzs',
  'uah',
  'ugx',
  'uyu',
  'uzs',
  'vnd',
  'vuv',
  'wst',
  'xaf',
  'xcd',
  'xof',
  'xpf',
  'yer',
  'zar',
  'zmw',
]

// Keep in sync with the `EnrolmentType` enum in `apps/billing/enums.py`.
export const ENROLMENT_TYPES = {
  NEW: 'New Sale',
  RENEWAL: 'Renewal',
}

export const SUBJECTS = {
  MATH: 'Math',
  CODING: 'Coding',
  ELA: 'ELA',
} as const
export type SubjectType = typeof SUBJECTS[keyof typeof SUBJECTS]

// Subject and course values stay "Coding..." in the backend; only the label
// customers and sales see is rebranded. Only a leading "Coding" is renamed,
// so names like "Rising Coding Star" keep theirs.
export const aiCodingLabel = (value: string) =>
  value.replace(/^Coding\b/, 'AI & Coding')
